import PropTypes from 'prop-types'
import { Pagination } from 'antd'
import classnames from 'classnames'

const Paginator = ({
  className,
  currentPage,
  total,
  loadPage,
  pageSize = 10,
  showLessItems,
}) => {
  return (
    <Pagination
      className={classnames('mb-4', className)}
      current={currentPage}
      total={total}
      onChange={(page, size) => {
        loadPage(page, size)
      }}
      showSizeChanger={true}
      defaultPageSize={pageSize}
      pageSize={pageSize}
      showLessItems={showLessItems}
    />
  )
}

Paginator.propTypes = {
  currentPage: PropTypes.number,
  total: PropTypes.number,
  loadPage: PropTypes.func,
  pageSize: PropTypes.number,
  showLessItems: PropTypes.bool,
}

export default Paginator
